import {
  Directive, OnInit, OnDestroy,
  ChangeDetectorRef, HostBinding, Input,
} from '@angular/core';

import { SideDrawerService } from 'shared/sidedrawer/sidedrawer.service';
import {takeWhile} from 'rxjs/operators';


@Directive({
  selector: '[sidedrawerResponsive]',
  exportAs: 'sidedrawer-responsive',
})
export class SideDrawerResponsiveDirective implements OnInit, OnDestroy {

  isActive: boolean = true;
  sidedrawerWidth: number;

  @HostBinding('style.width') get width() {
    return this.sidedrawerWidth ? `calc(100% - ${this.sidedrawerWidth}px)` : '';
  }

  constructor(
    private ref: ChangeDetectorRef,
    private sidedrawerService: SideDrawerService,
  ) {}

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    this.sidedrawerService.widthChange
      .pipe(takeWhile(() => this.isActive))
      .subscribe((sidedrawerWidth: any) => {
        this.sidedrawerWidth = sidedrawerWidth;
        this.ref.markForCheck();
      });
  }

  ngOnDestroy() {
    this.isActive = false;
  }
}
